import styled, { keyframes } from 'styled-components';
import { Button } from 'antd';

const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

export const ActionBubbleBarWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  animation: ${fadeSlideIn} 200ms ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ActionBubbleLabel = styled.span`
  flex-basis: 100%;
  font-size: 12px;
  color: #888;
  margin-bottom: 2px;
`;

export const ActionBubbleButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: auto;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  transition: all 0.2s ease;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;
    background-color: #f0f7ff;
  }

  &:active {
    transform: scale(0.98);
  }

  .anticon {
    font-size: 14px;
  }
`;

export const ShimmerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
`;

export const ShimmerPill = styled.div`
  height: 32px;
  border-radius: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;

  &:nth-child(1) {
    width: 120px;
  }

  &:nth-child(2) {
    width: 100px;
  }

  &:nth-child(3) {
    width: 90px;
  }
`;
